import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { BrowserStorageService } from '../service/browser-storage-service';
import { AuthService } from '../service/auth-service';
import { EncryptionService } from '../service/encryption-service';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const router = inject(Router);
  const browserStorage = inject(BrowserStorageService);
  const authService = inject(AuthService);
  const encryptionService = inject(EncryptionService);

  if (authService.loggedIn) {
    return true;
  }

  if (!authService.hasRefreshToken()) {
    browserStorage.clearSession();
    browserStorage.setSessionItem('loggedIn', 'false');
    router.navigate(['/auth/sign-in'], { queryParams: { returnUrl: state.url }, replaceUrl: true });
    return false;
  }

  return authService.refreshAccessToken().pipe(
    map((response: any) => {
      if (response?.access_token) {
        const encrypted = encryptionService.encryptionAES(response.access_token);
        browserStorage.setSessionItem('app_params', encrypted);
        browserStorage.setSessionItem('loggedIn', 'true');
        return true;
      }
      browserStorage.clearSession();
      browserStorage.setSessionItem('loggedIn', 'false');
      router.navigate(['/auth/sign-in'], { queryParams: { returnUrl: state.url }, replaceUrl: true });
      return false;
    }),
    catchError(() => {
      browserStorage.clearSession();
      browserStorage.setSessionItem('loggedIn', 'false');
      router.navigate(['/auth/sign-in'], { queryParams: { returnUrl: state.url }, replaceUrl: true });
      return of(false);
    })
  );
};
